// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/AuthorCard.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/AuthorCard.tsx");
  import.meta.hot.lastModified = "1732036225876.6633";
}
// REMIX HMR END

import { Image } from "@unpic/react";
import Heading from "./Heading";
/**
 * Renders an Author Card block with borders, title, text and a rounded image.
 * 
 * @param picture The avatar of the author. 
 * @param name The full name of the author.
 * @param jobTitle The job title of the author.
 * @param bio A short description of the author.
 * 
 * @returns An author card block.
 * 
 */

export default function AuthorCard({
  picture,
  name,
  jobTitle,
  bio
}) {
  return <section className="border rounded-4xl border-secondary-400 md:flex md:space-x-6 items-center p-6 bg-white">
        <Image width={160} height={160} layout="fixed" className="rounded-full shrink-0 max-w-max mb-4 md:mb-0" src={picture?.mediaImage.url} alt={picture?.mediaImage.alt} />
        <div className="text-neutral-600">
            <Heading tag="h2">About the author</Heading>
            <div className="font-bold">{name}, {jobTitle}</div>
            <div>{bio}</div>
        </div>

    </section>;
}
_c = AuthorCard;
var _c;
$RefreshReg$(_c, "AuthorCard");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;